import { RulesetData } from "../domain/ruleset.js";
import v1_1_0 from "./1.1.0.json";
import latest from "./latest.json";

/**
 * All rulesets bundled with the app. Armies reference one of these via their
 * `ruleset_version`, see {@link RulesetRegistry}.
 */
export const rulesetDatas: RulesetData[] = [latest, v1_1_0];
